import { Component, OnInit } from "@angular/core";
import { ActivatedRoute,Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { ResponseObject } from "src/app/Services/auth.service";
import { InstagramService } from "src/app/Services/instagram.service";
import { NotificationsService } from "src/app/Services/shared/notifications.service";
import { SocialPostService } from 'src/app/Services/social-post.service';
import { NotificationTypes } from "src/app/app.enums";
import { TranslocoService } from '@jsverse/transloco';


@Component({
    selector: 'app-connect-with-instagram',
    templateUrl: './connect-with-instagram.component.html',
    standalone: false
})

export class ConnectWithInstagram implements OnInit{
    constructor(
      private activatedRoute:ActivatedRoute,
      private ngxSpinnerService:NgxSpinnerService,
      private SocialPostService:SocialPostService,
      private router: Router,
      private notificationsService: NotificationsService,
      private instagramService: InstagramService,
      private transloco: TranslocoService){

    }
    ngOnInit(): void {
        this.activatedRoute.queryParams.subscribe((params) => {
            if (params['code'] && params['state']) {
              this.onInstagramCallBack(params['code'],params['state'])
            }else{
              this.ngxSpinnerService.hide();
              this.router.navigate(['/instagram-account'])
              this.notificationsService.showNotification(this.transloco.translate('connectWithInstagram.errorTitle'), this.transloco.translate('connectWithInstagram.connectionCancelled'), NotificationTypes.Error);
            }
          });
    }

    public onInstagramCallBack(code: string,state: string){
      // this.ngxSpinnerService.show();
      // this.SocialPostService.onSocialAccountsCallBack(code, state).subscribe((InstagramApiResponce: ResponseObject) => {
      //   console.log(InstagramApiResponce);
      //   if (InstagramApiResponce.Success) {
      //     this.notificationsService.showNotification('Success', InstagramApiResponce.ResponseMessage, NotificationTypes.Success);
      //     //this.router.navigate([this.artistId , 'artworks' ,this.selectedProductId])
      //     this.router.navigate(['/social-accounts'])
      //   }
      //   this.ngxSpinnerService.hide();
      // }, error => { console.log(error); this.ngxSpinnerService.hide(); });
      this.ngxSpinnerService.show();
      this.instagramService.onInstagramAccountsCallBack(code, state).subscribe((InstagramApiResponce: ResponseObject)=>{
        console.log(InstagramApiResponce);
        if (InstagramApiResponce.Success) {
          this.notificationsService.showNotification(this.transloco.translate('connectWithInstagram.successTitle'), InstagramApiResponce.ResponseMessage, NotificationTypes.Success);
          //this.router.navigate([this.artistId , 'artworks' ,this.selectedProductId])
          this.router.navigate(['/instagram-account'])
        }else{
          this.ngxSpinnerService.hide();
          this.router.navigate(['/instagram-account'])
          this.notificationsService.showNotification(this.transloco.translate('connectWithInstagram.errorTitle'), InstagramApiResponce.ResponseMessage, NotificationTypes.Error);
        }
        this.ngxSpinnerService.hide();
      }, error => { console.log(error); this.ngxSpinnerService.hide(); })
    }
}